import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { makePath } from 'helpers/link-generation';
import { selectActiveVenue } from 'selectors/general';
import { selectLocale } from 'selectors/locale-data';

import YourPrivacyChoicesModal from './YourPrivacyChoicesModal';

const mapStateToProps = state => {
  const { venueId } = selectActiveVenue(state);
  const locale = selectLocale(state);

  return {
    contactUsUrl: makePath.contactUs(venueId, locale),
  };
};

const mergeProps = (stateProps, dispatchProps) => ({ ...stateProps, dispatchProps });

export default compose(injectIntl, connect(mapStateToProps, {}, mergeProps))(YourPrivacyChoicesModal);
